<template>
  <div class="home">
    <PurchasingPaymentGroupList v-show="listView" @newPayment="onClickNewFromList" @editPayment="onClickEditFromList" :idx="idx" :scroll="corY" ref="refreshList"/>
    <PurchasingPaymentGroupForm v-show="formView" :payment="payment" @backClicked="onBackChild" @backSaveClicked="onBackSaveChild"/>
  </div>
</template>

<script>
// @ is an alias to /src
import PurchasingPaymentGroupList from '@/components/payment/PurchasingPaymentGroupList.vue'
import PurchasingPaymentGroupForm from '@/components/payment/PurchasingPaymentGroupForm.vue'
import { mapState } from 'vuex'

export default {
  name: 'PurchasingPaymentGroup',
  components: {
    PurchasingPaymentGroupList,
    PurchasingPaymentGroupForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      idx: null,
      payment: {
        id: null,
        group_no: null,
        prepayment_date: null,
        payment_date: null,
        category: 'purchasing',
        subtotal: '0',
        round: '0',
        penalty_amount: '0',
        total: '0',
        method_id: null,
        method: null,
        type_id: null,
        type: null,
        bank_id: null,
        bank: null,
        account_code: null,
        account: null,
        notes: null,
        vendor_no: null,
        vendor: null,
        customer_no: null,
        customer: null,
        branch_no: null,
        branch: null,
        company_no: null,
        company: null,
        status: null,
        lock: false,
        report_no: null,
        discount_percentage: '0',
        discount: '0',
        finish_date: null,
        giro_no: null,
        bank_name: null,
        ref_no: null,
        finish: false,
        manual_journal: false,
        purchasings: [{
          id: null,
          payment_no: null,
          purchasing_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          method: null,
          type_id: null,
          type: null,
          bank_id: null,
          bank: null,
          notes: null,
          prepayment_date: null,
          group_no: null,
          account_code: null,
          account: null,
          finish: false
        }],
        refs: [{
          group_no: null,
          total: 0
        }]
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      console.log(x + '|' + y)
      this.listView = false
      this.formView = true
      this.payment = value.data
      this.idx = value.index
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      console.log(x + '|' + y)
      this.listView = false
      this.formView = true
      this.payment = {
        id: null,
        group_no: null,
        prepayment_date: null,
        payment_date: new Date().toISOString(),
        category: 'purchasing',
        subtotal: '0',
        round: '0',
        penalty_amount: '0',
        total: '0',
        method_id: null,
        method: null,
        type_id: null,
        type: null,
        bank_id: null,
        bank: null,
        account_code: null,
        account: null,
        notes: null,
        vendor_no: null,
        vendor: null,
        customer_no: null,
        customer: null,
        branch_no: this.authUser.branch_no,
        branch: null,
        company_no: this.authUser.company_no,
        company: null,
        status: null,
        lock: false,
        report_no: null,
        discount_percentage: '0',
        discount: '0',
        finish_date: null,
        giro_no: null,
        bank_name: null,
        ref_no: null,
        finish: true,
        manual_journal: false,
        purchasings: [],
        refs: [{
          group_no: null,
          total: 0
        }]
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.payment = {
        id: null,
        group_no: null,
        prepayment_date: null,
        payment_date: null,
        category: 'purchasing',
        subtotal: '0',
        round: '0',
        penalty_amount: '0',
        total: '0',
        method_id: null,
        method: null,
        type_id: null,
        type: null,
        bank_id: null,
        bank: null,
        account_code: null,
        account: null,
        notes: null,
        vendor_no: null,
        vendor: null,
        customer_no: null,
        customer: null,
        branch_no: null,
        branch: null,
        company_no: null,
        company: null,
        status: null,
        lock: false,
        report_no: null,
        discount_percentage: '0',
        discount: '0',
        finish_date: null,
        giro_no: null,
        bank_name: null,
        ref_no: null,
        finish: false,
        manual_journal: false,
        purchasings: [{
          id: null,
          payment_no: null,
          purchasing_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          method: null,
          type_id: null,
          type: null,
          bank_id: null,
          bank: null,
          notes: null,
          prepayment_date: null,
          group_no: null,
          account_code: null,
          account: null,
          finish: false
        }],
        refs: [{
          group_no: null,
          total: 0
        }]
      }
      // this.$refs.refreshList.refreshProduct()
    },
    async onBackSaveChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.payment = {
        id: null,
        group_no: null,
        prepayment_date: null,
        payment_date: null,
        category: 'purchasing',
        subtotal: '0',
        round: '0',
        penalty_amount: '0',
        total: '0',
        method_id: null,
        method: null,
        type_id: null,
        type: null,
        bank_id: null,
        bank: null,
        account_code: null,
        account: null,
        notes: null,
        vendor_no: null,
        vendor: null,
        customer_no: null,
        customer: null,
        branch_no: null,
        branch: null,
        company_no: null,
        company: null,
        status: null,
        lock: false,
        report_no: null,
        discount_percentage: '0',
        discount: '0',
        finish_date: null,
        giro_no: null,
        bank_name: null,
        ref_no: null,
        finish: false,
        manual_journal: false,
        purchasings: [{
          id: null,
          payment_no: null,
          purchasing_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          method: null,
          type_id: null,
          type: null,
          bank_id: null,
          bank: null,
          notes: null,
          prepayment_date: null,
          group_no: null,
          account_code: null,
          account: null,
          finish: false
        }]
      }
      this.$refs.refreshList.refreshList()
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser
    })
  },
  mounted () {
    this.$store.dispatch('getPaymentTypeList')
    this.$store.dispatch('getPaymentMethodList')
    this.$store.dispatch('getVendorList')
    this.$store.dispatch('getChartOfAccountList')
    this.$store.dispatch('getCompanyList')
  }
}
</script>
